import PropTypes from 'prop-types';
import React, {
  createContext, useContext, useMemo, useState,
} from 'react';

import OrderDetail from './detail';

const OrderDetailContext = createContext({});

export default function OrderDetailProvider({ children }) {
  const [orderId, setOrderId] = useState();
  const [defaultShipIdx, setDefaultShipIdx] = useState(null);

  const orderContextValue = useMemo(() => ({
    setOrderId,
    setDefaultShipIdx,
  }), []);
  return (
    <OrderDetailContext.Provider value={orderContextValue}>
      <OrderDetail
        orderId={orderId}
        defaultShipIdx={defaultShipIdx}
        onClose={() => {
          setOrderId(null);
          setDefaultShipIdx(null);
        }}
      />
      {children}
    </OrderDetailContext.Provider>
  );
}
OrderDetailProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const useOrderDetail = () => {
  const context = useContext(OrderDetailContext);
  return context;
};
